import { FormattedMessage } from 'react-intl';
import { labelsForGermanProducts } from '../components/ESignature/Constants/constants';
import React from 'react';

export const getFinanceProductValue = (countryCode, financeProduct) => {
    if (countryCode === 'DE') {
        return <FormattedMessage id={labelsForGermanProducts[financeProduct]} />
    }
    return financeProduct;
}

export const validateDuplicateEmailMobileSigners = (signersInfo, suppressEmailMobileValidation, setDuplicateEmailMobileErrorState, setDuplicateEmailMobileErrorState2) => {
    if (signersInfo.length > 0) {
        const duplicateEmailMobileNoSigners = new Set();
        const tempDuplicateEmailMobileArray = [];
        signersInfo.forEach((signer) => {
            for (let i = signersInfo.indexOf(signer); i < signersInfo.length; i++) {
                if (i !== signersInfo.indexOf(signer)) {
                    const isDuplicateEmailMobileNo =
                        !suppressEmailMobileValidation && 
                        signer.name.toLowerCase() !== signersInfo[i].name.toLowerCase() &&
                        ((signer.emailID && signersInfo[i].emailID && signer.emailID.toLowerCase() === signersInfo[i].emailID.toLowerCase()) ||
                            signer.phoneNumber === signersInfo[i].phoneNumber);
                    if (isDuplicateEmailMobileNo) {
                        duplicateEmailMobileNoSigners.add(signer.tpNumber + '_' + signersInfo[i].tpNumber);

                    } else {
                        duplicateEmailMobileNoSigners.delete(signer.tpNumber + '_' + signersInfo[i].tpNumber);
                    }
                }
            }
        });
        duplicateEmailMobileNoSigners.forEach((sign) =>
            tempDuplicateEmailMobileArray.push(...sign.split('_'))
        );
        setDuplicateEmailMobileErrorState(duplicateEmailMobileNoSigners, tempDuplicateEmailMobileArray);

    } else if (signersInfo.length === 0) {
        setDuplicateEmailMobileErrorState2();
    }
}

export const validateDuplicateSignersMethods = (signersInfo, setDuplicateSignersErrorState, setDuplicateSignersErrorState2) =>{
    if (signersInfo.length > 0) {
        const duplicateSigners = new Set();
        const tempDuplicateSignersArray = [];
        signersInfo.forEach((signer) => {
            for (let i = signersInfo.indexOf(signer); i < signersInfo.length; i++) {
                if (i !== signersInfo.indexOf(signer)) {
                    const isDuplicate =
                        signer.name.toLowerCase() === signersInfo[i].name.toLowerCase() &&
                        (signer.emailID && signersInfo[i].emailID && signer.emailID.toLowerCase() === signersInfo[i].emailID.toLowerCase()) &&
                        signer.phoneNumber === signersInfo[i].phoneNumber &&
                        signer.signingOrder === signersInfo[i].signingOrder;
                    if (isDuplicate) {
                        if (signer.signingMethod !== signersInfo[i].signingMethod) {
                            duplicateSigners.add(signer.tpNumber + '_' + signersInfo[i].tpNumber);
                        } else if (signer.signingMethod === signersInfo[i].signingMethod) {
                            duplicateSigners.delete(signer.tpNumber + '_' + signersInfo[i].tpNumber);
                        }
                    } else {
                        duplicateSigners.delete(signer.tpNumber + '_' + signersInfo[i].tpNumber);
                    }
                }
            }
        });
        duplicateSigners.forEach((sign) =>
            tempDuplicateSignersArray.push(...sign.split('_'))
        );
        setDuplicateSignersErrorState(duplicateSigners, tempDuplicateSignersArray);
    } else if (signersInfo.length === 0) {
        setDuplicateSignersErrorState2();
    }
}
